<template>
  <div
    :class="$style.rootContainer"
    @click="handleFocus"
  >
    <i :class="[ $style.searchIcon, 'jc-actions-search' ]" />
    <div :class="$style.searchContainer">
      <div
        v-for="filter in selectedValues"
        :key="filter.value"
        :class="$style.pillContainer"
      >
        <Pill
          :ref="`pill-${filter.value}`"
          :handleDeleteButtonClick="() => handleFilterDelete(filter)"
          :showDeleteButton="true"
          :text="filter.name"
        />
      </div>
      <div :class="$style.inputContainer">
        <input
          ref="searchInput"
          :class="$style.searchInput"
          data-test-id="SearchBar__searchInput"
          :placeholder="placeholderText"
          type="text"
          :value="searchText"
          @blur="handleBlur"
          @input="handleSearchInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Pill from 'client/components/Buttons/Pill.vue';

/**
 *   @event {string} input - search value has changed
 *   @event {{ value: any, name: string}} filterDelete - filter delete has been clicked
 *   @event focus - SearchBar has focus
 *   @event blur - SearchBar has lost focus
 */
export default {
  name: 'SearchBarLegacy',

  components: {
    Pill,
  },

  mixins: [
    clickaway,
  ],

  props: {
    placeholderText: {
      type: String,
      default: 'Search',
    },
    searchText: {
      type: String,
      required: true,
    },
    /**
     * @type {{ value: any, name: string }[]}
     */
    selectedValues: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    inputTextLeft: 0,
    searchClearButtonLeft: 80,
  }),

  methods: {
    handleBlur() {
      this.$emit('blur');
    },

    handleFilterDelete(filter) {
      this.$emit('filterDelete', filter);
    },

    /**
     * Force focus on the input when the user clicks anywhere in the search bar.
     */
    handleFocus() {
      this.$refs.searchInput.focus();
      this.$emit('focus');
    },

    handleSearchClearButtonClick() {
      this.$emit('input', '');
    },

    handleSearchInput(event) {
      const { value } = event.target;
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped module>
@import "./css/SearchBar.css";
</style>
